(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-drawer')) {
    customElements.define(
      'header-drawer',
      class HeaderDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.openers = document.querySelectorAll('[data-drawer-open]');
          this.onOpen = () => this.open();
          this.openers.forEach((button) => button.addEventListener('click', this.onOpen));
          this.querySelector('[data-drawer-close]').addEventListener('click', () => this.close());
          // Close when clicking the backdrop (outside the dialog box).
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog.addEventListener('close', () => {
            this.openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
          });
        }

        disconnectedCallback() {
          this.openers?.forEach((button) => button.removeEventListener('click', this.onOpen));
        }

        open() {
          this.dialog.showModal();
          this.openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
        }

        close() {
          this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Judge.me's icon-font stars (its StarRating component): one glyph per state.
    const STAR_STATES = { '\ue000': 'filled', '\ue001': 'empty', '\ue002': 'half' };

    const markStars = (section) => {
      section.querySelectorAll('.jm-star-rating__font-icon').forEach((star) => {
        const state = STAR_STATES[star.textContent.trim()];
        if (state) {
          if (star.dataset.star !== state) star.dataset.star = state;
        } else if (star.dataset.star) {
          delete star.dataset.star;
        }
      });
    };

    // A product without reviews of its own opens on the store's reviews (Michelly, 2026-10-26). Judge.me has no
    // setting for the first tab, so its tab is picked once, when the widget has drawn it.
    const openStoreTab = (section) => {
      if (section.dataset.storeTabPicked || Number(section.dataset.reviewCount) > 0) return;
      const tabs = [...section.querySelectorAll('.jdgm-tab[role="tab"]')];
      if (tabs.length < 2) return;
      const store = tabs.find((tab) => /loja/i.test(tab.textContent)) || tabs[1];
      section.dataset.storeTabPicked = 'true';
      if (store.getAttribute('aria-selected') !== 'true') store.click();
    };

    const start = () => {
      document.querySelectorAll('.product-reviews').forEach((section) => {
        // The widget draws itself after the page loads and redraws on each tab, page or filter change.
        const update = () => {
          markStars(section);
          openStoreTab(section);
        };
        update();
        new MutationObserver(update).observe(section, { childList: true, subtree: true, characterData: true });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
